"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RANGE_INDICES = exports.TYPE_VALUES = exports.TODAY_INDEX = exports.PAST_DAYS_NUMBER = void 0;
exports.PAST_DAYS_NUMBER = 10;
exports.TODAY_INDEX = exports.PAST_DAYS_NUMBER;
exports.TYPE_VALUES = {
    seven: 7,
    fourteen: 14,
    thirty: 30,
    fortyFive: 45,
    sixty: 60,
    ninety: 90,
    oneEighty: 180,
};
exports.RANGE_INDICES = [17, 24, 40, 55, 70, 100, 190];
